import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useUpdateUserRoleMutation } from "../../../store/slice/tradeApi";
import styles from "../admin.module.css";

const ROLES = [
  { id: 1, title: "admin", label: "Admin" },
  { id: 2, title: "user", label: "Utilisateur" },
  { id: 3, title: "candidate", label: "Candidat" },
  { id: 4, title: "banned", label: "Banni" },
];

function RoleModal({ user, onClose }) {
  const [selectedRoleId, setSelectedRoleId] = useState(user.role_id);
  const [updateUserRole, { isLoading }] = useUpdateUserRoleMutation();
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (selectedRoleId === user.role_id) {
      onClose();
      return;
    }
    try {
      await updateUserRole({ id: user.id, role_id: selectedRoleId }).unwrap();
      onClose();
    } catch (err) {
      setError(err.data?.msg || "Erreur lors de la mise à jour");
    }
  };

  return (
    <div className={styles.modalContent}>
      <button
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          border: "none",
          background: "none",
          cursor: "pointer",
        }}
        onClick={onClose}
      >
        <FontAwesomeIcon icon={faXmark} size="xl" color="red" />
      </button>

      <h3>Modifier le rôle</h3>
      <p>
        Utilisateur : <strong>{user.alias}</strong> ({user.email})
      </p>

      <div className={styles.roleOptions}>
        {ROLES.map((role) => (
          <label key={role.id} className={styles.roleOption}>
            <input
              type="radio"
              name="role"
              value={role.id}
              checked={selectedRoleId === role.id}
              onChange={() => setSelectedRoleId(role.id)}
            />
            {role.label}
          </label>
        ))}
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className={styles.modalBtns}>
        <button
          className={styles.btnConfirm}
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {isLoading ? "..." : "Confirmer"}
        </button>
        <button className={styles.btnCancel} onClick={onClose}>
          Annuler
        </button>
      </div>
    </div>
  );
}

export default RoleModal;
